import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { TenantDriverDto } from '../../dtos/tenant-driver.dto';
import { updateTenantDriverSchema } from '../schemas/update-tenant-driver.schema';

/**
 * Validates driver record.
 * @param driver - The driver record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const isValidTenantDriver = (
	driver: TenantDriverDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!driver) throw new Error('Driver is required');

	// Validate
	const { error } = updateTenantDriverSchema().validate(driver, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
